export default "__VITE_ASSET__BhV$SMVe__"